import styles from './BundlePriceSelection.module.css';
import BundlePriceTableCard from '../NavigationCodeTableCard/BundlePriceTableCard';
import { BundlePriceSelectionProps } from '../CreateNavCode.types';
import { useTranslation } from 'react-i18next';
import { Row } from '@tanstack/react-table';

export function priceMatches(row: BundlePrice, filterValue: string) {
  if (row.price.toString().includes(filterValue)) return true;
  return false;
}
export interface BundlePrice {
  price: number;
}
export const BundlePriceSelection = (props: BundlePriceSelectionProps) => {
  const { t } = useTranslation();
  const { bundleData, selectedRows, setSelectedRows, selectedBundles } = props;

  const columns = [
    {
      accessorKey: 'price',
      header: t('common.bundle.bundlePrice'),
      filterFn: (row: Row<BundlePrice>, columnId: string, filterValue: string) =>
        priceMatches(row.original, filterValue),
      enableSorting: true,
    },
  ];
  return (
    <div className={styles.stepTwo}>
      <div className={styles.accordionContainer}>
        <div className={styles.navigationCodeTableCards}>
          <BundlePriceTableCard
            enableRowSelection
            width="calc(100vw - 250px)"
            title={t('common.bundle.prices')}
            data={bundleData || []}
            selectedRows={selectedRows}
            onRowSelectionChange={setSelectedRows}
            columns={columns}
            returnedRecordsText={(count) => t('bundleLibrary.table.returnedRecord', { count })}
            enableFilters
          />
        </div>
        <div className={styles.navigationCodeTableCards}>
          <BundlePriceTableCard
            width="calc(100vw - 250px)"
            title={t('common.bundle.selectedPrices')}
            data={selectedBundles}
            columns={columns}
            returnedRecordsText={(count) => t('bundleLibrary.table.returnedRecord', { count })}
            enableFilters
          />
        </div>
      </div>
    </div>
  );
};
